export default __webpack_public_path__ + "static/media/Skey-Network-Cube.ec631a57.png";